import NepaliDate from 'nepali-date-converter';
import { Fragment, useEffect, useState } from 'react';
import { Badge, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  FaAngleRight,
  FaCalendarDay,
  FaPlus,
  FaRegEdit,
  FaRegMoneyBillAlt,
  FaUserCog,
  FaUserGraduate,
  FaUserShield
} from 'react-icons/fa';
import { AiOutlineShareAlt } from 'react-icons/ai';

import { GiArcheryTarget, GiHumanTarget } from 'react-icons/gi';
import { GoLocation } from 'react-icons/go';
import { RiCalendarEventLine } from 'react-icons/ri';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link,
  Outlet,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
  useResolvedPath
} from 'react-router-dom';
import AvatarStack, { StyledSeeAllContainer } from '../../../../Components/AvatarStack/AvatarStack';
import LoadingComponent from '../../../../Components/LoadingComponent';
import TabItem from '../../../../Components/TabItem';
import { ThematicAreaBadge } from '../../../../Components/ThematicAreaBadge';
import UserInfoAvatar from '../../../../Components/UserInfo/UserInfoAvatar';
import { getEventById, handleAppliedEvent } from '../../../../Redux/slices/event';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
import { TargetedParty } from '../EventsTable/components/style';
import ModalOverlay from './components/ModalOverlay';
import { checkPermission } from '../../../../_helpers/roles/check-roles';
import { toast } from 'react-toastify';
import { VscLoading } from 'react-icons/vsc';
import UserImage from '../../../../Components/UserImage';

function EventDetailsLayout() {
  const intl = useIntl();
  const { id, token } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user);
  const { local } = useSelector((state) => state.local);
  const lang = useSelector((state) => state.local.local);
  const { loading, event } = useSelector((state) => state.event);

  const [hasEnded, setHasEnded] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const [applyLoading, setApplyLoading] = useState(false);

  const state = location?.state;
  const activeRole = user?.active_role;
  const isAdmin = location.pathname.includes('admin');

  const [showAllRP, setShowAllRP] = useState(false);
  useEffect(() => {
    localStorage.setItem('eventToken', token);
    return () => {
      localStorage.removeItem('eventToken');
    };
  }, []);

  const handleCloseRP = () => setShowAllRP(false);

  const resourcePersonStack = event?.resource_person?.map((person) => ({
    username: person.user__fullname || person.fullname,
    avatar: person.user__image || person.image,
    id: person.id
  }));

  const handleApply = async (e, id) => {
    if (!user) {
      dispatch(handleAppliedEvent(id));
      navigate('/signin');
    } else {
      try {
        setApplyLoading(true);
        await fetchWrapper.post(`/event/${id}/participate/`, '', '', lang);
        e.target.innerHTML = intl.formatMessage({ id: 'applied' });
        e.target.disabled = true;
        toast.success(intl.formatMessage({ id: 'applied_to_event' }));
        setApplyLoading(false);
      } catch (error) {
        ErrorMessageHandler(error);
        setApplyLoading(false);
      }
    }
  };
  useEffect(() => {
    dispatch(getEventById(id));
  }, []);

  let Tabs = [
    { title: 'event.participants', link: `participants` },
    { title: 'event.resourcePerson', link: `roster` },
    { title: 'event.session', link: 'event_sessions' },
    { title: 'event.attendance', link: 'attendence' },
    { title: 'event.courses', link: 'courses' }
  ];

  useEffect(() => {
    if (event) {
      const eventEndDate = new Date(event.end_date);
      const eventStartDate = new Date(event.start_date);
      const currentDate = new Date();
      if (eventEndDate < currentDate) {
        setHasEnded(true);
      }
      if (eventStartDate < currentDate && eventEndDate > currentDate) {
        setHasStarted(true);
      }
    }
  }, [event]);

  var pattern = /^((http|https|ftp):\/\/)/;

  let link = '';
  if (pattern.test(event?.virtual_link)) {
    link = event?.virtual_link;
  } else {
    link = 'https://' + event?.virtual_link;
  }

  return (
    <>
      <div className="card mb-3">
        <div className="card-body pb-0">
          {loading ? (
            <LoadingComponent />
          ) : (
            <div className="row pb-4 event-hero-section">
              <div className="col-md-2 text-center">
                {!hasStarted && !hasEnded && (
                  <span className="d-block mt-2 mx-1 badge bg-info">Up-Coming</span>
                )}
                {hasStarted && (
                  <span className="d-block mt-2 mx-1 badge bg-warning">In-Progress</span>
                )}
                {hasEnded && <span className="d-block mt-2 mx-1 badge bg-success">Completed</span>}
                <span className="mt-2 d-block">
                  <RiCalendarEventLine size={'50px'} className="text-muted" />
                </span>
                <h6 className="badge bg-secondary">#EV - {event?.id}</h6>
                <div className="cdmis-asip-linkage mt-2">
                  <small className="d-block border-dashed">
                    <span className="text-muted">Activity No. :</span>
                    <br />
                    {event.activity_count}
                  </small>
                  <small className="d-block border-dashed mt-2">
                    <span className="text-muted">Output No. :</span>
                    <br />
                    {event.output_number}
                  </small>
                </div>
                {/* //TODO : presentation section  */}
                {/* <div className="event-meta-actions mt-2">
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 150, hide: 50 }}
                    overlay={<Tooltip>Presentation Mode</Tooltip>}>
                    <a href="#">
                      <FiExternalLink size={35} style={{ transform: 'rotate(270deg)' }} />
                    </a>
                  </OverlayTrigger>
                </div> */}
              </div>
              <div className="col-md-10 border-3 border-start border-danger">
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex justify-content-between text-primary">
                      <div className="d-flex event-title-wrapper event-title">
                        <h1>
                          <FormattedMessage
                            id="event.title"
                            defaultMessage="Unknown"
                            values={{
                              title: local === 'ne' ? event?.title_nepali : event?.title_english
                            }}
                          />
                        </h1>
                        <div className="d-flex">
                          <Badge bg="success" className="ms-1" style={{ height: 'fit-content' }}>
                            {event?.program_type}
                          </Badge>
                          {event?.mtot ? (
                            <Badge bg="success" className="ms-1" style={{ height: 'fit-content' }}>
                              {' '}
                              MTOT
                            </Badge>
                          ) : null}
                        </div>
                      </div>
                      <div className="d-flex">
                        {!event?.completed && checkPermission(user?.active_role, 'edit event') && (
                          <div className="d-block h-auto ps-5">
                            <Link to={`edit/0`}>
                              <Button
                                className="d-flex align-items-center btn btn-outline-primary"
                                variant="outline-success ">
                                <FaRegEdit size={20} className="me-1" />{' '}
                                <FormattedMessage id="edit" />
                              </Button>
                            </Link>
                          </div>
                        )}

                        {['superuser', 'cd_admin', 'executive'].includes(user?.active_role) ? (
                          <div className="d-block h-auto ps-2">
                            <button
                              className="d-flex align-items-center btn btn-outline-primary"
                              type="button"
                              onClick={() => setModalShow(true)}>
                              <AiOutlineShareAlt size={20} className="me-1" /> Share
                            </button>
                            {modalShow && (
                              <ModalOverlay show={modalShow} onHide={() => setModalShow(false)} />
                            )}
                          </div>
                        ) : (
                          <div className="d-block h-auto 2">
                            {!['superuser', 'cd_admin', 'executive'].includes(user?.active_role) &&
                            !['ongoing', 'completed'].includes(state?.from) ? (
                              <button
                                className="d-flex align-items-center btn-sm btn btn-outline-primary"
                                type="button"
                                onClick={(e) => handleApply(e, id)}
                                disabled={applyLoading}>
                                {applyLoading ? (
                                  <VscLoading className="spin" />
                                ) : (
                                  <>
                                    <FormattedMessage id="apply" />
                                    <FaAngleRight />
                                  </>
                                )}
                              </button>
                            ) : null}
                            {/* {modalShow && (
                            <ModalOverlay show={modalShow} onHide={() => setModalShow(false)} />
                          )} */}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="w-75">
                    <div className="event-summary mb-3 fs-6 text-muted">
                      <p>{event?.summary}</p>
                    </div>
                    <div className="row m-0">
                      <div className="col-auto border-dashed event-meta rounded me-2 mb-2 d-flex align-items-start">
                        <span className="text-muted d-flex align-items-center">
                          <FaCalendarDay />
                          <FormattedMessage id="event.date" /> :
                        </span>
                        <span className="ms-1">
                          {local === 'ne'
                            ? event?.start_date_bs
                              ? new NepaliDate(event?.start_date_bs).format('YYYY-MM-DD', 'np')
                              : event?.start_date
                            : event?.start_date_bs}
                        </span>
                        <span className="mx-1"> | </span>
                        <span>
                          {local === 'ne'
                            ? event?.end_date_bs
                              ? new NepaliDate(event?.end_date_bs).format('YYYY-MM-DD', 'np')
                              : event?.end_date
                            : event?.end_date_bs}
                        </span>
                      </div>
                      <div className="col-auto border-dashed event-meta rounded me-2 mb-2  d-flex align-items-start">
                        <span className="text-muted d-flex align-items-center">
                          <GoLocation />
                          <FormattedMessage id="event.location" /> :
                        </span>
                        {event?.nature == 'physical' ? (
                          <span className="ms-1">
                            {event.physical_location_details?.tole != undefined
                              ? `${event.physical_location_details?.tole} - `
                              : null}
                            {event.physical_location_details?.ward != undefined
                              ? `${event.physical_location_details?.ward}, `
                              : null}
                            {`${event.physical_location_details?.local_level}, ${event.physical_location_details?.district}, ${event.physical_location_details?.province}`}
                          </span>
                        ) : (
                          <span className="ms-1">
                            <a href={link} target="_blank" rel="noreferrer">
                              Check Event
                            </a>
                          </span>
                        )}
                      </div>
                      {isAdmin && (
                        <div className="col-auto border-dashed event-meta rounded me-2 mb-2  d-flex align-items-start">
                          <span
                            className="text-muted d-flex align-items-center"
                            style={{ height: 'fit-content' }}>
                            <FaRegMoneyBillAlt />
                            <FormattedMessage id="estimated_budget" /> :
                          </span>
                          <span className="ms-1">
                            {local === 'ne' ? 'रु. ' : 'Rs. '}
                            {event?.estimated_budget}
                          </span>
                        </div>
                      )}

                      <div className="col-auto border-dashed event-meta rounded me-2 mb-2 d-flex align-items-start">
                        <div className="d-flex bd-highlight ">
                          <span
                            className=" text-muted d-flex align-items-center"
                            style={{ height: 'fit-content' }}>
                            <GiArcheryTarget />
                            <FormattedMessage id="event.targetedParticipants" />:{' '}
                          </span>
                          <div className=" flex-fill bd-highlight">
                            <span className="d-flex">
                              {event?.expected_participant_sector && (
                                <ul className="ps-3 mb-0">
                                  {event?.expected_participant_sector.map((target, index) => (
                                    <TargetedParty key={index}>
                                      {target?.title}{' '}
                                      {target?.parent__title ? `(${target?.parent__title})` : ''}
                                    </TargetedParty>
                                  ))}
                                </ul>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-auto border-dashed event-meta rounded me-2 mb-2 d-flex align-items-start">
                        <div className="d-flex bd-highlight">
                          <span
                            className=" text-muted d-flex align-items-center"
                            style={{ height: 'fit-content' }}>
                            <GiHumanTarget />
                            <FormattedMessage id="event.thematicArea" /> :
                          </span>
                          <div className=" flex-fill bd-highlight">
                            <ul className="ps-3 mb-0">
                              {event?.thematic_areas?.length ? (
                                event?.thematic_areas?.map((thematicArea) => {
                                  return (
                                    <ThematicAreaBadge key={thematicArea.id}>
                                      {local === 'ne'
                                        ? thematicArea?.title_nepali
                                        : thematicArea?.title_english
                                        ? thematicArea?.title_english
                                        : thematicArea?.title_nepali}
                                    </ThematicAreaBadge>
                                  );
                                })
                              ) : (
                                <li className="text-secondary">
                                  <i>
                                    <FormattedMessage id="event.no_thematicArea" />
                                  </i>
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-12 border-dashed rounded"></div> */}
                    </div>
                  </div>
                  <div className="w-25">
                    {isAdmin ? (
                      <Fragment>
                        <div className="">
                          <span className="text-cap d-flex align-items-center text-muted">
                            <FaUserShield />
                            <span className="ms-1">
                              <FormattedMessage id="created_by" /> :
                            </span>
                          </span>
                          <div className="d-flex p-1 ms-3">
                            {event?.created_by && <UserInfoAvatar user={event.created_by} />}
                          </div>
                        </div>
                        <div className="pt-3">
                          <span className="text-cap  text-muted ">
                            <FaUserCog />
                            <span className="ms-1">
                              <FormattedMessage id="event.managedBy" /> :
                            </span>
                          </span>
                          <div className="p-1 ms-3">
                            {event?.active_executive && (
                              <UserInfoAvatar user={event.active_executive} />
                            )}
                          </div>

                          {['superuser', 'cd_admin'].includes(user?.active_role) ? (
                            <small className="ms-1 btn btn-link p-0">
                              <Link to={`/admin/events/${id}/edit_managers`}>
                                <FaPlus className="me-2" />
                                <FormattedMessage id={'event.addExecutive'} />
                              </Link>
                            </small>
                          ) : null}
                        </div>
                        <div className="pt-3">
                          <span className="text-cap d-flex align-items-center text-muted ">
                            <FaUserGraduate />
                            <span className="ms-1">
                              <FormattedMessage id={'event.resourcePerson'} />:
                            </span>
                          </span>
                          <div className=" p-1 ms-3">
                            {Boolean(resourcePersonStack?.length) && (
                              <AvatarStack stack={resourcePersonStack} />
                            )}
                          </div>

                          {user && user?.profile_id === event?.active_executive?.id ? (
                            <small className="ms-1 btn btn-link p-0">
                              <Link to={`/admin/events/${id}/roster`}>
                                <FaPlus className="me-2" />
                                <FormattedMessage id="event.addResourceperson" />
                              </Link>
                            </small>
                          ) : null}
                          {['superuser', 'cd_admin'].includes(user?.active_role) ? (
                            <small className="ms-1 btn btn-link p-0">
                              <Link to={`/admin/events/${id}/roster`}>
                                <FaPlus className="me-2" />
                                <FormattedMessage id="event.addResourceperson" />
                              </Link>
                            </small>
                          ) : null}
                        </div>
                      </Fragment>
                    ) : (
                      <div className="pt-3">
                        <span className="text-cap d-flex align-items-center text-muted ">
                          <FaUserGraduate />
                          <span className="ms-1">
                            <FormattedMessage id={'event.resourcePerson'} />:
                          </span>
                        </span>
                        <div className=" p-1 ms-3">
                          {Boolean(resourcePersonStack?.length) && (
                            <Fragment>
                              {resourcePersonStack?.slice(0, 4)?.map((rp) => {
                                return (
                                  <div key={rp.id} className="d-flex align-items-center mb-2">
                                    <UserImage
                                      userName={rp.username}
                                      userId={`${rp.id}`}
                                      avatar={rp.image}
                                    />
                                    <span className="ms-2 d-block">{rp.username}</span>
                                  </div>
                                );
                              })}
                              {resourcePersonStack?.length - 4 > 0 && (
                                <>
                                  <OverlayTrigger
                                    key={'123'}
                                    placement="top"
                                    delay={{ show: 150, hide: 50 }}
                                    overlay={
                                      <Tooltip id="button-tooltip">
                                        <div>View all</div>
                                      </Tooltip>
                                    }>
                                    <div
                                      className="mb-4 btn btn-secondary py-1 px-3 text-center"
                                      style={{ position: 'relative' }}
                                      onClick={() => {
                                        setShowAllRP(true);
                                      }}>
                                      <FormattedMessage id="button.seeAll" />
                                    </div>
                                  </OverlayTrigger>
                                  <Modal show={showAllRP} onHide={handleCloseRP} centered>
                                    <Modal.Header closeButton>
                                      <Modal.Title>
                                        <FormattedMessage id="resourcePersons" /> (
                                        {resourcePersonStack?.length})
                                      </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <StyledSeeAllContainer>
                                        {resourcePersonStack.map((item) => (
                                          <div key={item.id} className="d-flex mb-2">
                                            <div>
                                              <UserImage
                                                userName={item.username}
                                                userId={`${item.id}`}
                                                avatar={item.image}
                                              />
                                            </div>
                                            <div className="d-flex ms-2 align-items-center">
                                              <div>{item.username}</div>
                                              {item.message && <div> {item.message}</div>}
                                            </div>
                                          </div>
                                        ))}
                                      </StyledSeeAllContainer>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={handleCloseRP}>
                                        Close
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                </>
                              )}
                            </Fragment>
                          )}
                        </div>

                        {user && user?.profile_id === event?.active_executive?.id ? (
                          <small className="ms-1 btn btn-link p-0">
                            <Link to={`/admin/events/${id}/roster`}>
                              <FaPlus className="me-2" />
                              <FormattedMessage id="event.addResourceperson" />
                            </Link>
                          </small>
                        ) : null}
                        {['superuser', 'cd_admin'].includes(user?.active_role) ? (
                          <small className="ms-1 btn btn-link p-0">
                            <Link to={`/admin/events/${id}/roster`}>
                              <FaPlus className="me-2" />
                              <FormattedMessage id="event.addResourceperson" />
                            </Link>
                          </small>
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {isAdmin ? (
          <div
            className="card-footer"
            style={{
              backgroundColor: 'white',
              borderBottomLeftRadius: '15px',
              borderBottomRightRadius: '15px'
            }}>
            <ul className="nav event-navigator" id="eventTab" role="tablist">
              {isAdmin ? (
                <TabButton title={'event.profile'} link={`/admin/events/${id}/`} />
              ) : (
                <TabButton title={'event.profile'} link={`/events/${id}/`} />
              )}
              {Tabs?.map((tab) => {
                return <TabButton title={tab.title} key={tab.title} link={tab.link} />;
              })}
              {isAdmin && ['superuser', 'cd_admin'].includes(activeRole) && (
                <TabButton title={'event.executives'} link={'edit_managers'} />
              )}
              {isAdmin && hasEnded && (
                <TabButton title={'event.postEventActivity'} link={'post_event_activity'} />
              )}
            </ul>
          </div>
        ) : (
          ''
        )}
      </div>
      {isAdmin ? <Outlet /> : null}
    </>
  );
}

export default EventDetailsLayout;

const TabButton = ({ title, link }) => {
  let resolved = useResolvedPath(link);
  let match = useMatch({ path: resolved.pathname, end: true });
  return <TabItem title={title} link={link} isActive={match} />;
};
